module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.d90ac76c.png";